import { isDevelopment, logger } from "@/betby/api/httpLogger";

const md5Cache = new Map<string, string>();

export function md5Hex(text: string): string {
  if (md5Cache.has(text)) {
    return md5Cache.get(text)!;
  }

  let encrypted: string;

  try {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const { MD5Helper } = require("@iap/kit-encryptor");

    if (typeof MD5Helper.CreateMD5 === "function") {
      encrypted = MD5Helper.CreateMD5(text);
    } else {
      try {
        const md5 = new MD5Helper();
        if (typeof md5.md5Hex === "function") {
          encrypted = md5.md5Hex(text);
        } else if (typeof md5.encrypt === "function") {
          const result = md5.encrypt(text);
          encrypted =
            typeof result === "string"
              ? result
              : result?.hex || result?.toString() || text;
        } else {
          throw new Error("MD5Helper 实例方法不可用");
        }
      } catch {
        throw new Error("MD5Helper 方法不可用");
      }
    }
  } catch (error) {
    if (isDevelopment) {
      logger.debug(
        "[md5Hex] 使用 @iap/kit-encryptor 失败，使用备用方案:",
        error,
      );
    }

    // 浏览器环境使用 crypto-js
    try {
      // eslint-disable-next-line @typescript-eslint/no-require-imports
      const CryptoJS = require("crypto-js");
      encrypted = CryptoJS.MD5(String(text)).toString().toUpperCase();
    } catch {
      logger.error(
        "[md5Hex] 浏览器环境需要 crypto-js 库，请安装: npm install crypto-js @types/crypto-js",
      );
      throw new Error(
        "MD5 加密功能不可用，请确保 @iap/kit-encryptor 或 crypto-js 已正确安装",
      );
    }
  }

  md5Cache.set(text, encrypted);
  return encrypted;
}
